export class Discipline {
    constructor(
        public idDiscipline?: number,
        public code?: string,
        public llDiscipline?: string,
        public lcDiscipline?: string,
        public anneeDebut?: number,
        public anneeFin?: number,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/discipline.model.ts